module.exports = __webpack_public_path__ + "img/ZJ5331.33e7ada5.png";